import AppService from "./app-service"

export default class CertTemplateService extends AppService {

  constructor() {
    super({ path: "cert-templates" })
  }
}